module.exports = __webpack_public_path__ + "assets/dist/images/pattern-greystripe.png";